<template>
  <div id="container" class="cs_st service_introduce">
    <!-- Location START -->
    <!-- TODO: ADD SUBBAR COMPONENT -->
    <!-- <BaseLocation current-group-name="information" /> -->
    <div class="background">
      <div class="section fill intro">
        <div class="background_pc">
          <h1>
            서비스 소개 및 이용가이드
          </h1>
          <img
            src="@/assets/images/new_detailpage/guide/tit_under.png"
            alt=""
          />
          <p>
            캠퍼스북에서 제공하는 전자책에서는 <br />
            <em class="bg_yellow">단어 검색 한 번으로</em>
            해당 페이지를 바로 찾을 수 있으며, <br />
            <em class="bg_pink">실시간 메모</em>도 물론 가능합니다.<br />
            도서 내용과 연결되는 사진, 동영상도<br />
            나만의 노트에 삽입하고
            <em class="bg_blue">언제 어디서나 확인</em>
            할 수 있습니다.<br />
          </p>
        </div>
        <div id="background_mb">
          <h1>
            서비스 소개 및 이용가이드
          </h1>
          <img
            src="@/assets/images/new_detailpage/guide/tit_under.png"
            alt=""
          />
          <p>
            캠퍼스북에서 제공하는 전자책에서는 <br />
            <em class="bg_yellow">단어 검색 한 번으로</em>
            해당 페이지를 바로 <br />
            찾을 수 있으며,
            <em class="bg_pink">실시간 메모</em>도 물론 가능합니다.<br />
            도서 내용과 연결되는 사진, 동영상도<br />
            나만의 노트에 삽입하고
            <em class="bg_blue">언제 어디서나</em><br />
            확인 할 수 있습니다.
          </p>
        </div>
      </div>
    </div>
    <div class="background2">
      <div class="section fill intro">
        <div class="background_pc">
          <p>
            구입부터 학습까지! 원클릭 접속으로 장소와 시간에 <br />
            구애 받지 않고 사용할 수 있습니다.
            <em style="font-size: 16px;">(단, 온라인 환경에서만 이용 가능)</em
            ><br />
            급변하는 시대에 맞춰 더욱 편리한 학습 환경에 기초를 두고 있습니다.
          </p>
          <h1>
            이제 무거운 전공도서, 한 손에 모두 가지고 다니세요! <br />
            독서가 일상이 되는 방법, 캠퍼스북이 제시합니다.
          </h1>
          <img
            data-aos="fade-up"
            class="banner_icon"
            src="@/assets/images/new_detailpage/guide/banner_icon.png"
            alt=""
          />
        </div>
        <div id="background_mb">
          <p>
            구입부터 학습까지!<br />
            원클릭 접속으로 장소와 시간에 <br />
            구애 받지 않고 사용할 수 있습니다.<br />
            <em>(단, 온라인 환경에서만 이용 가능)</em><br />
          </p>
          <p style="padding-top: 10px;">
            급변하는 시대에 맞춰 더욱 편리한<br />
            학습 환경에 기초를 두고 있습니다.
          </p>
          <h1>
            이제 무거운 전공도서, <br />한 손에 모두 가지고 다니세요! <br />
            독서가 일상이 되는 방법, <br />캠퍼스북이 제시합니다.
          </h1>
          <img
            data-aos="fade-up"
            class="banner_icon"
            src="@/assets/images/new_detailpage/guide/banner_icon.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="introduce_cont pb pt">
      <div class="sub_tit section fill" data-aos="fade-up">
        <img
          src="@/assets/images/new_detailpage/sub_tit.png"
          alt="서브타이틀이미지"
        />
        <h4>전자책 구매 방법</h4>
      </div>
      <div class="bg_box bg_box1">
        <div class="section fill c_wrap">
          <div class="float-left c_box01">
            <img
              src="@/assets/images/new_detailpage/1.png"
              alt="01"
              class="pc_01"
              style="width: 65px;"
            />
            <img
              src="@/assets/images/new_detailpage/1.png"
              alt="01"
              class="mb_01"
              style="width: 53px;"
            />
            <h2>구매/대여</h2>
            <h5>
              원하는 구매 방식 선택<br />
              (구매(소장) / 6,12개월 대여)
            </h5>
            <p>
              검색 후 원하시는 결제방식으로<br />
              구매(소장), 대여(6개월/12개월)중<br />
              학습자 편의에 맞게 선택하여<br />
              전자결제를 진행합니다.
            </p>
          </div>
          <div class="float-right c_box01" data-aos="fade-up">
            <img
              src="@/assets/images/new_detailpage/guide/1-1_img.png"
              alt="구매/대여"
            />
          </div>
        </div>
      </div>
      <div class="bg_box bg_box1">
        <div class="section fill c_wrap">
          <div class="float-left c_box01">
            <img src="@/assets/images/new_detailpage/2.png" alt="02" />
            <h2>내 서재</h2>
            <h5>
              구매, 대여한 도서 <br />
              내서재 확인 후 이용
            </h5>
            <p>
              <img
                src="@/assets/images/new_detailpage/guide/guide2-1.png"
                alt="1번"
                style="width: 20px; vertical-align: middle; margin-right: 3px;"
              />
              내 서재에서 구매하신 도서를 확인하고<br />
              <em style="padding-left: 27px;">
                e-Book 보기 버튼을 통해 이용하실 수 있습니다.
              </em>
            </p>
            <p style="margin-top: 5px;">
              <img
                src="@/assets/images/new_detailpage/guide/guide2-2.png"
                alt="2번"
                style="width: 20px; vertical-align: middle; margin-right: 3px;"
              />
              내 책장 추가를 통해 나만의 도서분류가 가능합니다.<br />
              <em style="padding-left: 27px;">
                남은 대여일수도 내 서재에서 확인 가능합니다.
              </em>
            </p>
          </div>
          <div class="float-right c_box01" data-aos="fade-up">
            <img
              src="@/assets/images/new_detailpage/guide/1-2_img.png"
              alt="증정코드 발송"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="introduce_cont pb pt">
      <div class="sub_tit sub_tit2 section fill">
        <img
          src="@/assets/images/new_detailpage/sub_tit.png"
          alt="서브타이틀이미지"
        />
        <h4>뷰어 이용 방법</h4>
      </div>
      <div class="bg_box bg_box2">
        <div class="section fill c_wrap">
          <div class="float-left">
            <img
              src="@/assets/images/new_detailpage/guide/1.png"
              alt="01"
              class="pc_01"
              style="width: 70px;"
            />
            <img
              src="@/assets/images/new_detailpage/guide/1.png"
              alt="01"
              class="mb_01"
              style="width: 55px;"
            />
            <h2>기능 소개</h2>
            <h5>
              상단 OPEN 버튼 클릭 시<br />
              도구 모음 아이콘 활성화
            </h5>
            <p>
              전자책 상단의 OPEN버튼을 <br />
              클릭하시면 다양한 도구 기능을<br />
              사용할 수 있습니다.
            </p>
          </div>
          <div class="float-right1 float-right c_box01" data-aos="fade-up">
            <img
              src="@/assets/images/new_detailpage/guide/2-1_img.png"
              alt="기능 소개"
            />
          </div>
        </div>
      </div>
      <div class="bg_box bg_box2">
        <div class="section fill c_wrap">
          <div class="float-left" style="padding-top: 110px;">
            <img src="@/assets/images/new_detailpage/guide/2.png" alt="02" />
            <h2>도구 사용법&저장</h2>
            <h5>
              필기, 메모, 링크를<br />
              아이콘으로 간편하게
            </h5>
            <p>
              각 기능들은 한 화면에 <br />
              아이콘으로 표시되어 <br />
              학습에 편리함을 더해줍니다.<br />
              사용 후에는 저장 잊지마세요!
            </p>
          </div>
          <div class="float-right2 float-right c_box02" data-aos="fade-up">
            <img
              src="@/assets/images/new_detailpage/guide/2-2_img.png"
              alt="도구 사용법&저장"
            />
          </div>
        </div>
      </div>
      <div class="bg_box bg_box2">
        <div class="section fill c_wrap">
          <div class="float-left" style="padding-top: 90px;">
            <img src="@/assets/images/new_detailpage/guide/3.png" alt="03" />
            <h2>마이노트</h2>
            <h5>
              학습에 필요한 기능만을 모은<br />
              스마트한 학습파트너
            </h5>
            <p>
              기능이 없어 추가 어플을 쓰셨나요?<br />
              텍스트 스타일편집, 링크 삽입,<br />
              <img
                src="@/assets/images/new_detailpage/guide/guide3-1.png"
                alt="01"
                style="width: 19px; vertical-align: middle; margin-right: 4px;"
              />페이지 태그
              <img
                src="@/assets/images/new_detailpage/guide/guide3-2.png"
                alt="01"
                style="
                  width: 19px;
                  vertical-align: middle;
                  margin: 0 4px 0 8px;
                "
              />이미지,표
              <img
                src="@/assets/images/new_detailpage/guide/guide3-3.png"
                alt="01"
                style="
                  width: 19px;
                  vertical-align: middle;
                  margin: 0 4px 0 8px;
                "
              />동영상 삽입<br />
              이 모든 기능을 마이노트로 한번에<br />
              사용해 보세요.
            </p>
          </div>
          <div class="float-right3 float-right c_box03" data-aos="fade-up">
            <img
              src="@/assets/images/new_detailpage/guide/2-3_img.png"
              alt="마이노트"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="f_banner">
      <div class="section fill pc_f_banner">
        <h4>도서 구매 시 주의 사항</h4>
        <p>
          <img src="@/assets/images/new_detailpage/pink_dot.png" alt="" />
          대여의 경우 결제완료시점부터 계산됩니다. 내 서재에서 남은 일수를
          확인할 수 있습니다.
        </p>
        <p>
          <img src="@/assets/images/new_detailpage/pink_dot.png" alt="" />
          뷰어 사용은 온라인 환경에서만 가능합니다. 도서가 기기에 직접 다운로드
          되지 않습니다. 크롬에 최적화되어 있으며,<br />
          <em style="padding-left: 18px;">
            타 인터넷 브라우저 사용 시 원활한 이용이 어려우실 수 있습니다. 기타
            홈페이지 이용 사항에 대한 안내는<br />
          </em>
          <em style="padding-left: 18px;"
            >[고객센터>자주 묻는 질문]에서 확인 가능합니다.</em
          >
        </p>
      </div>
      <div class="section fill mb_f_banner">
        <h4>도서 구매 시 주의 사항</h4>
        <p>
          <img src="@/assets/images/new_detailpage/pink_dot.png" alt="" />
          대여의 경우 결제완료시점부터 계산됩니다.<br />
          <em style="padding-left: 18px;"
            >내 서재에서 남은 일수를 확인할 수 있습니다.</em
          >
        </p>
        <p>
          <img src="@/assets/images/new_detailpage/pink_dot.png" alt="" />
          뷰어 사용은 온라인 환경에서만 가능합니다.<br />
          <em style="padding-left: 18px;"
            >도서가 기기에 직접 다운로드 되지 않습니다.<br
          /></em>
          <em style="padding-left: 18px;"></em>크롬에 최적화되어 있으며,<br />
          <em style="padding-left: 18px;"> 타 인터넷 브라우저 사용 시 <br /></em
          ><em style="padding-left: 18px;"
            >원활한 이용이 어려우실 수 있습니다.</em
          >
          <br /><em style="padding-left: 18px;"
            >기타 홈페이지 이용 사항에 대한 안내는<br
          /></em>

          <em style="padding-left: 18px;"
            >[고객센터>자주 묻는 질문]에서 확인 가능합니다.</em
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swiper } from 'swiper/vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
export default {
  name: 'Guide',
  data() {
    return {}
  },
  computed: {
    viewerSwiper() {
      return this.$refs.viewerSwiper.$swiper
    },
    ebookSwiper() {
      return this.$refs.ebookSwiper.$swiper
    }
  },
  mounted() {
    AOS.init()
    // let that = this
    // that.mySwiper.on('init', () => {
    //   that.getActiveIndex(this)
    //   console.log(that.getActiveIndex(this))
    // })
  },

  methods: {
    toggleListMenu() {
      this.showListMenu = !this.showListMenu
    },
    closeListMenu() {
      this.showListMenu = false
    },
    activeIndexChange(i) {
      console.log(i)
    },
    slideChangeEbook() {
      this.eBookPg = parseInt(this.ebookSwiper.activeIndex) + 1
    },
    slideChangeViewer() {
      this.viewerPg = parseInt(this.viewerSwiper.activeIndex) + 1
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'NanumSquare';
  font-weight: 400;
  src: url('../../../src/assets/fonts/NanumSquareR.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 300;
  src: url('../../../src/assets/fonts/NanumSquareL.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 700;
  src: url('../../../src/assets/fonts/NanumSquareB.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 800;
  src: url('../../../src/assets/fonts/NanumSquareEB.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('ttf');
}

body,
h1,
h4,
p {
  font-family: 'pretendard-light';
}

.bg_yellow {
  background: linear-gradient(
    to top,
    rgba(252, 245, 157, 0.3) 50%,
    transparent 50%
  );
}

.bg_pink {
  background: linear-gradient(
    to top,
    rgba(244, 159, 189, 0.3) 50%,
    transparent 50%
  );
}

.bg_blue {
  background: linear-gradient(
    to top,
    rgba(102, 196, 255, 0.3) 50%,
    transparent 50%
  );
}

.mb_01,
.mb_p {
  display: none;
}

#background_mb {
  display: none;
}

.mb_f_banner {
  display: none;
}

.section.fill {
  width: 100%;
  max-width: 1120px;
  background: none;
}

.cs_st.service_introduce .background {
  background: url('../../assets/images/new_detailpage/guide/guide_banner.png')
    center no-repeat;
  .intro.fill {
    height: 630px;
    background: none;
    color: #fff;
    h1 {
      font-size: 2.5em;
      padding-top: 120px;
      margin-bottom: 20px;
    }

    p {
      font-size: 1.714em;
      padding-top: 40px;
      font-weight: lighter;
      color: #fff;
    }
  }
}
.background2 {
  background-color: #0f638f;
  text-align: center;
  box-sizing: border-box;
  position: relative;
  .intro.fill {
    height: 690px;
    background: none;
    p {
      color: #fdffd1;
      font-size: 20px;
      padding-top: 112px;
      font-weight: lighter;
    }
    h1 {
      font-size: 29px;
      padding-top: 50px;
      font-weight: 600;
      line-height: 40px;
    }
    .banner_icon {
      position: absolute;
      top: calc(90% - 185px);
      left: calc(50% - 282px);
      // 564 370
      // transform: translate(-50%, -50%);
    }
  }
}
.sub_tit {
  padding: 250px 0 43px;
  text-align: center;
  font-size: 2.214em;
  h4 {
    margin-top: 1.071em;
    font-weight: 900;
  }
}
.sub_tit2 {
  padding: 0px 0 43px;
}

.bg_box {
  position: relative;
  max-width: 1903px;
  margin: auto;
  height: 560px;
  background: url('../../assets/images/new_detailpage/guide/bg_box.png') right
    no-repeat;
  margin-bottom: 94px;

  .section.fill {
    background: none;

    .float-left {
      padding: 95px 0;

      img {
        width: 80px;
      }

      h2 {
        font-size: 3.286em;
        color: #878787;
        padding-top: 40px;
      }

      h5 {
        font-size: 1.714em;
        padding: 15px 0;
        font-weight: 500;
      }

      p {
        font-size: 1.214em;
        line-height: 30px;
      }
    }

    .float-right {
      position: absolute;
      right: -340px;
      top: 30px;
    }
  }
}

.bg_box.bg_box2 {
  background: url('../../assets/images/new_detailpage/guide/bg_box2.png') right
    no-repeat;
  .section.fill {
    .float-right1 {
      right: -300px;
      top: 0px;
      img {
        width: 1002px;
      }
    }
    .float-right2 {
      right: -200px;
      top: 110px;
    }
    .float-right3 {
      right: -20px;
      top: 80px;
    }
  }
}

.f_banner {
  width: 100%;
  padding: 65px 0;
  color: #fff;
  background: url('../../assets/images/new_detailpage/f_banner.png') center
    no-repeat;
  background-size: cover;

  .section.fill {
    background: none;
  }

  h4 {
    font-size: 1.5em;
    padding-bottom: 30px;
  }

  p {
    font-size: 1.214em;
    line-height: 35px;

    img {
      padding-right: 5px;
    }
  }
}

@media (max-width: 1120px) {
  .bg_box .section.fill {
    padding-left: 50px;
    padding-right: 50px;

    .float-right {
      top: 90px;
      right: -400px;

      img {
        width: 75%;
      }
    }
  }
  .bg_box.bg_box2 {
    .section.fill {
      .float-right1 {
        right: -400px;
        top: 100px;
        img {
          width: 60%;
        }
      }
      .float-right2 {
        right: -150px;
        top: 110px;
      }
      .float-right3 {
        right: -80px;
        top: 130px;
      }
    }
  }
}

@media (max-width: 830px) {
  .cs_st.service_introduce .introduce_cont p {
    padding-top: 0;
  }
  .background_pc {
    display: none;
  }

  #background_mb {
    display: block;
  }

  .pc_01,
  .pc_p {
    display: none;
  }

  .mb_01,
  .mb_p {
    display: block;
  }

  .mb_f_banner {
    display: block;
  }

  .pc_f_banner {
    display: none;
  }

  .cs_st.service_introduce .background {
    background: url('../../assets/images/new_detailpage/guide/guide_banner_mb.png')
      bottom no-repeat;
    background-size: cover;
    height: 491px;
    #background_mb {
      padding-left: 10px;
      h1 {
        padding-top: 50px;
        margin-bottom: 5px;
        font-size: 22px;
      }
      p {
        font-size: 15px;
        line-height: 29px;
      }
    }
  }
  .cs_st.service_introduce .background2 {
    #background_mb {
      h1 {
        padding-top: 40px;
        font-size: 24px;
      }
      p {
        font-size: 17px;
        color: #dbdbdb;
        padding-top: 80px;
        line-height: 28px;
      }
      .banner_icon {
        position: absolute;
        min-width: 320px;
        max-width: 60vw;
        // max-height: ;
        top: calc(80% - 16px);
        left: calc(50% - 30vw);
        // transform: translate(-50%, -50%);
      }
    }
  }

  .sub_tit {
    padding: 150px 0 20px;

    img {
      width: 37px;
    }

    h4 {
      font-size: 22px;
      margin-top: 15px;
    }
  }

  .sub_tit2 {
    padding: 80px 0 20px;
  }

  .bg_box {
    background: none;
    height: auto;
    background-color: #f3f8ff;
    margin-bottom: 50px;

    .section.fill {
      padding: 70px 0 50px 50px;

      .float-left {
        float: none;
        padding: 0px 0 30px !important;

        img {
          width: 65px;
        }

        h2 {
          font-size: 38px;
          padding-top: 20px;
        }

        h5 {
          font-size: 19px;
          padding: 8px 0 13px;
        }

        p {
          font-size: 12px;
          line-height: 23px;
        }
      }

      .float-right {
        position: static;
        float: none;
        img {
          width: 430px;
        }
      }
    }
  }
  .bg_box.bg_box2 {
    background: none;
    background-color: #fff8fa;
    .section.fill {
      padding: 70px 0px 0 50px;
      .float-right1 {
        img {
          width: 100%;
          max-width: 360px;
          margin-left: -15px;
        }
      }
      .float-right2 {
        img {
          width: 100%;
          max-width: 360px;
          margin-left: -10px;
        }
      }
      .float-right3 {
        img {
          width: 100%;
          max-width: 320px;
          margin-left: -10px;
        }
      }
    }
  }

  .last_bg_box {
    margin-bottom: 0;
  }

  .f_banner {
    padding: 30px 0 30px 20px;
  }

  .f_banner .mb_f_banner {
    p {
      line-height: 25px;
      margin-bottom: 10px;
    }
  }
}
@media screen and (min-width: 831px) and (max-width: 1280px) {
  .bg_box {
    height: auto;
  }
  .c_wrap {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > .c_box01.float-left {
      padding: 64px 0 !important;
      min-width: 366px;
    }
    > .float-right {
      position: static !important;
      &.c_box01 > img {
        height: 27.1875vw;
        width: auto !important;
      }
      &.c_box02 > img {
        height: 30vw;
        width: auto !important;
      }
      &.c_box03 > img {
        height: 36vw;
        width: auto !important;
      }
    }
  }
}
</style>
